import React from 'react';
import { Link } from 'react-router-dom';
import { useCard } from '../context/CardContext';
import '../styles/CardList.css'; // Ensure CSS is properly linked

export default function CardList() {
    const { cards, deleteCard } = useCard();

    return (
        <div className="container mt-3">
            <h2 className="text-white mb-3">My Cards</h2>
            <ul className="list-group">
                {cards.map((card) => (
                    <li key={card.id} className="list-group-item d-flex justify-content-between align-items-center">
                        <Link to={`/card/${card.id}`} className="text-decoration-none">{card.name}</Link>
                        <button onClick={() => deleteCard(card.id)} className="btn btn-danger">
                            Delete
                        </button>
                    </li>
                ))}
            </ul>
        </div>
    );
}
